module.exports = __webpack_public_path__ + "img/banner-nl-desktop.fec2b37e.jpg";